import { NgModule, inject} from '@angular/core';
import { Routes, RouterModule, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { LoginComponent } from './base/login/login.component';
import { ChangePasswordComponent } from './base/change-password/change-password.component';

import { HomeComponent } from './domain/home/home.component';
import { AuthGuard } from './base/guards/auth.guard';
import * as pages from './core/routing/page-names';
import { EditProfileComponent } from './base/edit-profile/edit-profile.component';
import { ForgotPasswordComponent } from './base/forgot-password/forgot-password.component';
import { NotDomainUserGuard } from './base/guards/not-domain-user.guard';
import { TwoFactorAuthenticationRegistrationComponent } from './base/two-factor-authentication/two-factor-authentication-registration/two-factor-authentication-registration.component';
import { TwoFactorAuthenticationRecoveryComponent } from './base/two-factor-authentication/two-factor-authentication-recovery/two-factor-authentication-recovery.component';
import { LocalLoginComponent } from './base/login/local-login/local-login.component';
import { OnboardingComponent } from './base/onboarding/onboarding.component';
import { SetPasswordStandaloneComponent } from './base/set-password-standalone/set-password-standalone.component';
import { AssetCollectionPublicViewComponent } from './domain/assets/asset-collections/asset-collection-public-view/asset-collection-public-view.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: pages.homePageName
  },
  {
    path: pages.homePageName,
    component: HomeComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.loginPageName,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: LoginComponent
      },
      {
        path: pages.localLoginPageName,
        component: LocalLoginComponent
      }
    ]
  },
  {
    path: pages.changePasswordPageName,
    component: ChangePasswordComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(NotDomainUserGuard).canActivate(route, state)]
  },
  {
    path: pages.editProfilePageName,
    component: EditProfileComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(NotDomainUserGuard).canActivate(route, state)],
  },
  {
    path: pages.setPasswordPageName,
    component: SetPasswordStandaloneComponent,
  },
  {
    path: pages.forgotPasswordPageName,
    component: ForgotPasswordComponent
  },
  {
    path: pages.twoFactorAuthenticationPageName,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: pages.registrationPageName
      },
      {
        path: pages.registrationPageName,
        component: TwoFactorAuthenticationRegistrationComponent,
      },
      {
        path: pages.recoveryPageName,
        component: TwoFactorAuthenticationRecoveryComponent
      }
    ]
  },
  {
    path: pages.onboardingPageName,
    component: OnboardingComponent,
  },
  {
    path: pages.assetCollectionPublicViewPageName,
    component: AssetCollectionPublicViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { /*enableTracing: true*/ })],
  exports: [RouterModule]
})

export class AppRoutingModule {}
